import { createContext } from 'react';

const TicketMessagesContext = createContext([[]]);

export { TicketMessagesContext };
